import { createSlice } from "@reduxjs/toolkit";


// Then, handle actions in your reducers:
const modalSlice = createSlice({
  name: "categories",
  initialState: {
    id: null,
    visibility: false,
    subModalId: null,
    subModalVisibility: false
  },
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
    hideModal(state, _action) {
      return { ...state, visibility: false };
    },
    showModal(state, action) {
      return { ...state, id: action.payload.id, visibility: true };
    },
    hideSubModal(state, _action) {
      return { ...state, subModalVisibility: false };
    },
    showSubModal(state, action) {
      return { ...state, subModalId: action.payload.id, subModalVisibility: true };
    },
  },
});

export const { hideModal, showModal, hideSubModal, showSubModal } = modalSlice.actions;
export default modalSlice.reducer;
